// removed by extract-text-webpack-plugin
module.exports = {"IdeaImageFullScreen":"IdeaImageFullScreen__3UX7v","CarouselContainer":"CarouselContainer__1z6sm","IdeaItemCard":"IdeaItemCard__3PocS","IdeaImgContainer":"IdeaImgContainer__ptqGE","IdeaItemLeft":"IdeaItemLeft__x-p51","IdeaItemRight":"IdeaItemRight__1p-vk","IdeaItemRightHead":"IdeaItemRightHead__1SJxr","LeftName":"LeftName__xgB9j","LeftTime":"LeftTime__1IhzS","Right":"Right__1nXqi","IdeaItemRightLike":"IdeaItemRightLike__2njY_","IdeaItemRightAward":"IdeaItemRightAward__2prQP","IdeaContent":"IdeaContent__3P0Aq","IdeaVideo":"IdeaVideo__jdSpz"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/IdeaItem/index.css
// module id = 677
// module chunks = 0